import { createActions } from "../../helpers/utils/createActions";
import { USER } from "./actionTypes";

export const getListaUser = createActions(USER.GET_LISTA_USER);
export const getDropDownUser = createActions(USER.GET_DROPDOWN_USER);
export const getUser = createActions(USER.GET_USER);
export const saveUser = createActions(USER.SAVE_USER);

export const loadEmptyUser = () => ({ type: USER.LOAD_EMPTY_USER });
export const cleanMessageUser = () => ({ type: USER.CLEAN_MESSAGE_USER });
export const changePageSizeUser = (payload) => ({ type: USER.CHANGE_PAGE_SIZE_USER, payload });
